import { useSnackbar } from 'notistack';
import DialogModal from '../../../../../atoms/dialog'
import FormCancelSubmitBtns from '../../../../../atoms/formCancelSubmitBtns';
import InviteExpertForm from './form';
import { handleInviteSubmit } from './helper';
import InviteBulk from './InviteBulk';
import { usePeMappingContext } from '../../helper';
import { ThandleInviteSubmit, TInviteExpertPE } from './type';

const InviteExpertPE = ({ isOpen, handleClose, isReInvite, pe_id, project_id, selectedCards, isMultiple, setLoading }: TInviteExpertPE) => {
  
  if (isMultiple) {
    return (
      <>
        <InviteBulk
          handleClose={handleClose}
          isOpen={isOpen}
          project_id={project_id}
          selectedCards={selectedCards}
          isReInvite={isReInvite}
          setLoading={setLoading}
        />
      </>
    )
  }

  const { enqueueSnackbar } = useSnackbar();
  const { refetch } = usePeMappingContext();

  const submitHandler = ({ sendInviteValue, shareAgendaValue, selectedAgendasValue }: Pick<ThandleInviteSubmit, 'sendInviteValue' | 'shareAgendaValue' | 'selectedAgendasValue'>) => {
    handleInviteSubmit({ setLoading, pe_id, sendInviteValue, shareAgendaValue, selectedAgendasValue, handleClose, enqueueSnackbar, refetch });
  }
  return (
    <DialogModal
      title={isReInvite ? "ReInvite Expert" : "Invite Expert"}
      isOpen={isOpen}
      handleClose={handleClose}
    >
      {(isMultiple && selectedCards.length === 0) ? <></> :
        <InviteExpertForm
          pe_id={pe_id}
          renderSubmitAndCloseComponent={() => <FormCancelSubmitBtns
            handleClose={handleClose}
          />}
          project_id={project_id}
          submitHandler={submitHandler}
        />
      }

    </DialogModal>
  )
}

export default InviteExpertPE